import type { LaunchFailure } from "../../../hooks/useOptroLaunchResolve";

// Full-page copy per failure kind, rendered by OptroLaunchError.
// Lives outside the component files so react-refresh stays happy.
export const LAUNCH_FAILURE_COPY: Record<LaunchFailure, string> = {
  expired:
    "This link has expired. Click Run Automated Test again in Optro to start over.",
  forbidden:
    "You don't have access to the Midship workspace connected to Optro. Ask an administrator to add you.",
  denied:
    "You don't have permission to do this in the Midship workspace connected to Optro. Ask an administrator about your role.",
  unreachable:
    "Midship couldn't read this control from Optro. Its connection may need reauthorizing.",
  networkError:
    "Midship couldn't be reached. Check your connection and try again.",
  serverError: "There was an error. Please try again.",
  unknown: "Something went wrong on our side. Please try again.",
};
